module.exports = __webpack_public_path__ + "media/application/images/footer/twitter-deedf45fedf5a2659bbca45bf8296e0b.svg";